import React from 'react';

interface TopBarProps {
  view: 'home' | 'game';
  onHome: () => void;
  onSponsor: () => void;
}

export function TopBar({ view, onHome, onSponsor }: TopBarProps) {
  return (
    <header className="topbar">
      <button className="brand" onClick={onHome} aria-label="返回游戏首页" style={{ background: 'none', border: 0, color: 'inherit', cursor: 'pointer', padding: 0 }}>
        <img className="brand-logo" src="./assets/images/vivagamelogo.png" alt="VIVA GAME" />
        <span className="brand-version">1.0 基础版</span>
      </button>
      <nav className="top-actions" aria-label="页面导航">
        {view === 'game' && <button className="nav-btn" onClick={onHome}>← <span className="optional">返回</span>游戏首页</button>}
        <a className="nav-btn" href="https://viva.net.cn" target="_blank" rel="noreferrer">↗ VIVA官网</a>
        <button className="nav-btn sponsor" onClick={onSponsor}>♡ 赞助支持</button>
      </nav>
    </header>
  );
}
